module.exports = __webpack_public_path__ + "static/info-12@2x.f1893369.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/mini_portal/Organization/info-12@2x.png
// module id = 834
// module chunks = 153456355441848